import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const Changelog = () => {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch('/Changelog.md')
      .then(response => response.text())
      .then(text => setMarkdown(text))
      .catch(error => console.error('Error fetching changelog:', error));
  }, []);

  return (
    <div className="mt-6 flex min-h-full items-center justify-center bg-stone-100 dark:bg-stone-700">
      <div className="h-[calc(100vh-178px)] w-full max-w-[65vw] overflow-hidden rounded-lg border border-stone-300 bg-stone-50 shadow-xl dark:border-stone-700 dark:bg-stone-900">
        <div className="flex h-full flex-col">
          <h1 className="border-b border-stone-300 p-6 text-3xl font-extrabold text-stone-800 dark:border-stone-700 dark:text-white">
            Changelog
          </h1>
          <div className="flex-1 overflow-y-auto px-3 pb-6">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                h1: ({ node, children, ...props }) => (
                  <h1 className="text-2xl font-semibold text-stone-800 dark:text-white mb-6" {...props}>
                    {children || 'Untitled Section'}
                  </h1>
                ),
                h2: ({ node, children, ...props }) => (
                  <h2 className="text-xl font-bold text-stone-700 dark:text-white mt-8 mb-4" {...props}>
                    {children || 'Untitled Subsection'}
                  </h2>
                ),
                h3: ({ node, children, ...props }) => (
                  <h3 className="text-lg font-medium text-stone-600 dark:text-gray-100 underline mt-6 mb-3" {...props}>
                    {children || 'Untitled Detail'}
                  </h3>
                ),
                ul: ({ node, ...props }) => (
                  <ul className="ml-6 list-disc space-y-4 text-stone-600 dark:text-gray-100" {...props} />
                ),
                li: ({ node, ...props }) => (
                  <li className="text-stone-600 dark:text-gray-100" {...props} />
                ),
                strong: ({ node, ...props }) => (
                  <strong className="text-stone-700 dark:text-white font-semibold" {...props} />
                ),
                p: ({ node, ...props }) => (
                  <p className="text-stone-600 dark:text-gray-100 mb-4" {...props} />
                ),
                hr: ({ node, ...props }) => (
                  <hr className="my-8 border-stone-300 dark:border-stone-700" {...props} />
                ),
              }}
            >
              {markdown}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Changelog;